import React, { ReactNode } from 'react';
import { Button, Modal } from 'antd';
import { CheckCircleIcon } from '@heroicons/react/24/solid';

interface IProps {
  open: boolean;
  title: string;
  content: string;
  handleOk: () => void;
  handleCancel: () => void;
  loading?: boolean;
  showInfo?: boolean;
  info?: ReactNode;
  showCancel?: boolean;
}

const ConfirmApprove = ({
  open,
  content,
  handleOk,
  handleCancel,
  loading,
  showInfo,
  info,
  showCancel = true,
}: IProps) => {
  return (
    <Modal
      width={400}
      open={open}
      onOk={() => handleOk}
      onCancel={() => (showCancel && handleCancel()) || undefined}
      okText="บันทึก"
      cancelText="ยกเลิก"
      closable={showCancel}
      footer={
        <div className="flex w-full gap-2 justify-center">
          {showCancel && (
            <Button key="back" onClick={handleCancel}>
              ยกเลิก
            </Button>
          )}
          <Button
            key="submit"
            type="primary"
            form="unit"
            onClick={handleOk}
            className="bg-green-700 !hover:bg-green-700"
            loading={loading}
          >
            ยืนยัน
          </Button>
        </div>
      }
    >
      <div className="flex flex-row w-full gap-5 items-center text-lg">
        <div>
          <CheckCircleIcon className="w-10 h-10 text-green-600" />
        </div>
        <div>{content}</div>
      </div>
      {showInfo && info}
    </Modal>
  );
};

export default ConfirmApprove;
